import type { IImpressionTeaser } from '@schibsted/pulse-sdk';
import type { WrappedTeaser } from '../../../../views/components/teasers/TeaserWrapper.js';
import type { PulseContextInputParams } from '../../../../../core/mandatory-integrations/pulse/types/index.js';

import {
  getContentAccessLevel,
  getElementSize,
  getTeaserImageUrl,
  getTeaserTitle,
  toAbsoluteUrl,
} from '../teaser-fields.js';

export interface TeaserViewAttributes {
  'data-track-event': string;
  'data-track-object-type': 'Teaser';
}

export const buildImpressionTeaserAttributes = (
  teaser: WrappedTeaser,
  targetUrl?: string,
): TeaserViewAttributes => {
  const title = getTeaserTitle(teaser);

  const event: PulseContextInputParams<IImpressionTeaser> = {
    object: {
      contentSource: teaser.pulseData?.contentSource ?? 'Capi',
      imageUrl: getTeaserImageUrl(teaser),
      name: 'Teaser',
      elementSize: getElementSize(teaser.size),
      objectId: teaser.id,
      title,
    },
    placement: {
      columnName: teaser.pulseData?.placement?.columnName ?? 'main',
      containerName: teaser.pulseData?.placement?.containerName ?? 'page',
      foldPosition: 'Unknown',
      positionInBundle: teaser.pulseData?.placement?.positionInBundle,
      primaryAxis: teaser.pulseData?.placement?.primaryAxis ?? 'Vertical',
      primaryPosition:
        teaser.index !== undefined
          ? teaser.index
          : (teaser.pulseData?.placement?.primaryPosition ?? 1),
      secondaryPosition: teaser.pulseData?.placement?.secondaryPosition ?? 1,
      curateContext: teaser.pulseData?.placement?.curateContext,
      source: 'src' in teaser ? teaser.src : undefined,
    },
    page: {
      content: {
        accessLevel: getContentAccessLevel(teaser),
        contentId: teaser.id,
        contentTitle: title,
        format: teaser.pulseData?.content?.format ?? 'Article',
        formatSubtype: teaser.pulseData?.content?.formatSubtype ?? 'Article',
        namespace: 'vink',
      },
    },
    target: {
      info: { url: targetUrl ? toAbsoluteUrl(targetUrl) : '' },
    },
  };

  return {
    'data-track-event': JSON.stringify(event),
    'data-track-object-type': 'Teaser',
  };
};
